export default __webpack_public_path__ + "f0b656ad5a0a2780246a4136964057f6.png";